import { DviView } from '../dvi/DviView';

/**
 * DVI レンダラの動作確認ページ (ナビゲーションには載せない開発用ルート)。
 * SabiTeX で組版した XDV をクライアントの wasm レンダラで表示する。
 */
export function DviDemo() {
  return (
    <>
      <div className="hero">
        <h1>DVI レンダラ デモ</h1>
        <p>
          SabiTeX で組版した DVI/XDV を、自作の wasm レンダラ (dvi-texture)
          でブラウザ内ラスタライズして表示しています。
        </p>
      </div>
      <section className="card">
        <h2>hello.dvi (XDV, Latin Modern)</h2>
        <DviView src="/demo/hello.dvi" layout="crop" />
      </section>
      <section className="card">
        <h2>japanese.dvi (DVI, JFM 和文)</h2>
        <p>JFM (umin10) の和文組版。実フォントは原ノ味明朝のサブセットで解決しています。</p>
        <DviView src="/demo/japanese.dvi" layout="crop" />
      </section>
      <section className="card">
        <h2>yakumono.dvi (DVI, 約物の寄せ)</h2>
        <p>
          開き括弧は右寄せ、中点・小書き仮名・？は中央寄せ、閉じ括弧・句読点は左寄せ。 xdvipdfmx
          の出力と一致することを確認済みです。
        </p>
        <DviView src="/demo/yakumono.dvi" layout="crop" />
      </section>
      <section className="card">
        <h2>mixed.dvi (XDV, 和欧混植)</h2>
        <p>欧文は Latin Modern (native font)、和文は JFM + 原ノ味明朝。禁則と xkanjiskip 入り。</p>
        <DviView src="/demo/mixed.dvi" layout="crop" />
      </section>
      <section className="card">
        <h2>specials.dvi (色 special と HyperTeX リンク)</h2>
        <p>
          dvips 形式の色 special (color push/pop) をレンダラが解釈し、HyperTeX の リンク special
          (html:&lt;a href&gt;) は透明な &lt;a&gt; のオーバーレイになります
          (ホバーで矩形が見えます)。
        </p>
        <DviView src="/demo/specials.dvi" layout="crop" align="left" />
      </section>
      <section className="card">
        <h2>tyco.dvi (pTeX, 2018 年の旧サイト資産)</h2>
        <p>
          旧サイトで配信していた「チコノフの定理」(pTeX + Computer Modern + jis メトリクス、全 8
          ページ)。本物の Type1 フォントで紙面 (A4) をヘッドライン・ノンブル・余白ごと再現し、
          fit-width 倍率で表示しています。ラスタライズは可視領域 ± 2 画面ぶんのみ遅延実行され
          (未描画ページは寸法確定済みのスケルトン)、ページ送り UI (pager=&quot;paged&quot;)
          も選択できます。
        </p>
        <DviView src="/pdf/tyco.dvi" scaling="fit-width" pager="scroll" frame background="paper" />
      </section>
    </>
  );
}
